import React from 'react';
import { CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { packageIncludes, pricing } from '../data/content';
type OfferSectionProps = {
  claimedPercent: number;
};
export function OfferSection({
  claimedPercent
}: OfferSectionProps) {
  return <section id="order" className="scroll-mt-16 border-b border-line bg-panel py-20 sm:py-24" data-id="element-149" data-mp="dfq04rebu3hl">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-150" data-mp="ifb09558ghvw">
        <div className="text-center" data-id="element-151" data-mp="me203k132dmp">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-152" data-mp="md0ewmqcsar9">
            Limited-time offer
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-153" data-mp="wcr90nb04nqt">
            Launch pricing expires in
          </h2>
          <div className="mt-8" data-id="element-154" data-mp="2t7mbij5439dp">
            <Countdown data-id="element-155" data-mp="2y3umdkca0gf2" />
          </div>
          <p className="mt-5 text-sm text-white/50" data-id="element-156" data-mp="2y4mgeqq86638">
            Launch pricing ends today. After that, the system returns to its
            standard price of $97.
          </p>
        </div>

        <div className="mt-10" data-id="element-157" data-mp="xv8rkhhflxx0">
          <div className="flex items-baseline justify-between text-[11px] font-semibold uppercase tracking-[0.16em]" data-id="element-158" data-mp="xuz1ktwdzqrb">
            <span className="text-white/45" data-id="element-159" data-mp="owdgos3fzznd">Limited availability — today only</span>
            <span className="text-acid" data-id="element-160" data-mp="1lme3wmo5y82k">{claimedPercent}% claimed</span>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden bg-night" role="progressbar" aria-valuenow={claimedPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Spots claimed" data-id="element-161" data-mp="1lk0ccnsozdzr">
            <div className="h-full bg-acid" style={{
            width: `${claimedPercent}%`
          }} data-id="element-162" data-mp="17m3d1jmusthe" />
          </div>
        </div>

        <div className="mt-10 border border-acid/40 bg-night" data-id="element-163" data-mp="3sd3tbptj5ay1">
          <div className="border-b border-line px-6 py-5 text-center sm:px-10" data-id="element-164" data-mp="3sex33dzfwba9">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-165" data-mp="3tuj0axxw3op1">
              The Total Academy System&trade; — complete package
            </p>
            <p className="mt-2 font-display text-3xl font-bold uppercase leading-none tracking-tight text-white sm:text-4xl" data-id="element-166" data-mp="3ks9pe6ypltb4">
              6 manuals + 5 strategic bonuses
            </p>
          </div>

          <div className="grid gap-10 px-6 py-9 sm:px-10 lg:grid-cols-2 lg:gap-12" data-id="element-167" data-mp="3b2gpi37xj2mp">
            <div data-id="element-168" data-mp="3fuhz1hdpqf91">
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-acid" data-id="element-169" data-mp="3fv0493ics3t3">
                What&rsquo;s included
              </p>
              <ul className="mt-5 space-y-3" data-id="element-170" data-mp="364evin8ytiwg">
                {packageIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-171" data-mp="2s4nmz217wupu">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-acid" aria-hidden="true" data-id="element-172" data-mp="2s5fjcf2n2wh6" />
                    <span className="text-sm leading-relaxed text-white/70" data-id="element-173" data-mp="2dh5gby43hq0s">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-center border-t border-line pt-8 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-174" data-mp="2mjoei4wxregp">
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-175" data-mp="2ifqhq0v32fqt">
                Total real value: {pricing.compare}
              </p>
              <div className="mt-3 flex items-baseline gap-4" data-id="element-176" data-mp="2rgonanl66vbi">
                <span className="font-display text-7xl font-extrabold leading-none text-acid" data-id="element-177" data-mp="366mdf92ntv3c">
                  {pricing.price}
                </span>
                <span className="font-display text-3xl font-bold text-white/35 line-through" data-id="element-178" data-mp="3181ere323jh0">
                  {pricing.compare}
                </span>
              </div>
              <p className="mt-4 inline-block self-start bg-acid px-3 py-1.5 font-display text-base font-bold uppercase tracking-tight text-night" data-id="element-179" data-mp="3a8z914np0cme">
                You save {pricing.savings} — {pricing.discount} off
              </p>
              <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/40" data-id="element-180" data-mp="1dgk1bmjeh8hl">
                One-time payment · Lifetime access
              </p>
            </div>
          </div>

          <div className="border-t border-line px-6 py-8 sm:px-10" data-id="element-181" data-mp="1m9ncfo6kp992">
            <CtaButton full label="Yes, I want the system" sublabel="Covered by our 7-day money-back guarantee" data-id="element-182" data-mp="pl7m3pvn2vuw" />
            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3" data-id="element-183" data-mp="yl463e7336jm">
              <li className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.16em] text-white/45" data-id="element-184" data-mp="13jxhn12t8nh5">
                <LockIcon className="h-4 w-4 text-acid" aria-hidden="true" data-id="element-185" data-mp="2a0sso4gfe3jw" />
                Secure payment
              </li>
              <li className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.16em] text-white/45" data-id="element-186" data-mp="2ext2mqgebqga">
                <ZapIcon className="h-4 w-4 text-acid" aria-hidden="true" data-id="element-187" data-mp="2p55c4vyoxa2q" />
                Instant access
              </li>
              <li className="text-[11px] font-medium uppercase tracking-[0.16em] text-white/45" data-id="element-188" data-mp="2fd7ylik7m60u">
                Card · Google Pay · Apple Pay
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}